module.exports = __webpack_public_path__ + "static/media/title_collections.c79256ed.svg";